import React from 'react'
import { Route } from 'react-router-dom'
import { withData } from '../Data';
import TopBar from './TopBar';
// pages
import Page_Root from '../pages/root';
import Page_Empresas from '../pages/empresas';
import Page_Metricas from '../pages/metricas';
import Page_GrupoEmpresas from '../pages/grpempresas';
import Page_Funcionarios from '../pages/funcionarios';
import Page_Dre from '../pages/dre';
import Page_Dre2 from '../pages/dre2';
import Page_Esocial from '../pages/esocial';
import Page_Logon from '../pages/logon';
import Page_UsuariosEditar from '../pages/usuarios/editar';
import Page_Usuarios_MinhaConta from '../pages/usuarios/minha-conta';
import PrivateRoute from '../Helpers/PrivateRoute';

const Content = props => {
  return (
    <div>
      <TopBar />
      <div style={{marginTop:"70px", marginLeft:"12px", height: '100%'}}>
        <Route exact path="/" render={() => <Page_Root {...props} />} />
        <PrivateRoute path="/empresas" render={() => <Page_Empresas {...props} />} />
        <PrivateRoute path="/metricas" render={() => <Page_Metricas {...props} />} />
        <PrivateRoute path="/grpempresas" render={() => <Page_GrupoEmpresas {...props} />} />
        <PrivateRoute path="/funcionarios" render={() => <Page_Funcionarios {...props} />} />
        <PrivateRoute path="/dre" render={() => <Page_Dre {...props} />} />
        <PrivateRoute path="/dre2" render={() => <Page_Dre2 {...props} />} />
        <PrivateRoute path="/esocial" render={() => <Page_Esocial {...props} />} />
        <Route path="/logon" render={() => <Page_Logon {...props} />} />
        <PrivateRoute path="/usuarios/editar" render={() => <Page_UsuariosEditar {...props} />} />
        <PrivateRoute path="/usuarios/minha-conta" render={() => <Page_Usuarios_MinhaConta {...props} />} />

      </div>
    </div>
  )
}

export default withData(Content)
